export default function deviceResolution() {
  return Math.round(Math.max(window.devicePixelRatio, 1))
}
